import React from "react";
import "./style.scss";
import Header from "../../components/Header";
import Order from "../../components/Order";
import FooterOrder from "../../components/FooterOrder";
import OrderIdle from "../../components/OrderIdle";

const OrderPage = () => {

    return <div className="OrderPage">
        <Header />
        <Order />
        <FooterOrder checkTableNumberSettings={true} />
        <OrderIdle />
    </div>
}

export default OrderPage;
